export const APP_STORE_URL =
  'https://apps.apple.com/us/app/gymahead/id6759555258'
const PLAY_STORE_URL = '#'
const COMING_SOON_LABEL = 'Coming soon'

// Official badge images served from Apple / Google CDNs
const APPLE_BADGE_SRC =
  'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us'
const GOOGLE_BADGE_SRC =
  'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'

interface AppStoreButtonsProps {
  centered?: boolean
  centeredOnMobile?: boolean
}

export function AppStoreButtons({
  centered = false,
  centeredOnMobile = false,
}: AppStoreButtonsProps) {
  const alignCls = centered
    ? 'justify-center'
    : centeredOnMobile
      ? 'justify-center lg:justify-start'
      : ''

  return (
    <div className={`flex flex-col sm:flex-row items-center gap-3 sm:gap-4 w-full sm:w-auto ${alignCls}`}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download on the App Store"
        title={APP_STORE_URL === '#' ? COMING_SOON_LABEL : 'Download on the App Store'}
        className="active:scale-95 transition-transform"
      >
        <img
          src={APPLE_BADGE_SRC}
          alt="Download on the App Store"
          className="h-11 sm:h-12 w-auto max-w-[180px] sm:max-w-none"
        />
      </a>

      <a
        href={PLAY_STORE_URL}
        aria-label="Get it on Google Play"
        title={PLAY_STORE_URL === '#' ? COMING_SOON_LABEL : 'Get it on Google Play'}
        className="active:scale-95 transition-transform"
      >
        <img
          src={GOOGLE_BADGE_SRC}
          alt="Get it on Google Play"
          // Google Play badge has extra padding baked in; compensate with negative margin
          className="h-[3.1rem] sm:h-[3.35rem] w-auto max-w-[200px] sm:max-w-none -my-[0.175rem]"
        />
      </a>
    </div>
  )
}
